import { UsStatesFull } from '@/components/EstimateWidget/FloatingVariation/FloatingForm/experiments/FinalExpenseInfoForm/utils/constants'

export const getStateAbbreviation = (fullName: string): string => {
  const entry = Object.entries(UsStatesFull).find(
    ([, name]) => name.toLowerCase() === fullName.toLowerCase()
  )
  return entry?.[0] ?? fullName
}
